import { useState, useTransition } from 'react';
import { Switch } from '../../ui/switch';
import { Loader2 } from 'lucide-react';
import { userService } from "../../../_services";

function ToggleSwitch({ numbering, payment, pageNumber, itemsPerPage, reload_UserList }) {
    const [error, setError] = useState('');
    const [isPending, startTransition] = useTransition();
    const [isChecked, setIsChecked] = useState(payment);

    const handleToggle = async (checked) => {
        try {
            setError('');
            
            startTransition(async () => {
                try {
                    const approvepayment = checked ? "true" : "false";
                    
                    // PRESERVE EXACT API CALL - DO NOT CHANGE
                    const response = await userService.ApproveUserPayment(numbering, approvepayment);
                    
                    if (response && response.length > 0) {
                        if (response[0].message === "Success") {
                            setIsChecked(checked);
                            
                            // Reload user list if callback provided
                            if (reload_UserList) {
                                reload_UserList(pageNumber, itemsPerPage);
                            }
                        } else {
                            setError(response[0].message);
                            // Revert the toggle on error
                            setIsChecked(!checked);
                        }
                    }
                } catch (err) {
                    console.error('Error toggling user payment approval:', err);
                    setError('Oops! Something went wrong. Please try again later.');
                    // Revert the toggle on error
                    setIsChecked(!checked);
                }
            });
        } catch (error) {
            console.error('Error in handleToggle:', error);
            setError('Oops! Something went wrong. Please try again later.');
            setIsChecked(!checked);
        }
    };

    return (
        <div className="flex items-center gap-2">
            <div className="relative">
                <Switch
                    checked={isChecked}
                    onCheckedChange={handleToggle}
                    disabled={isPending}
                    className="data-[state=checked]:bg-brand-accent"
                />
                {isPending && (
                    <Loader2 className="absolute inset-0 m-auto h-4 w-4 animate-spin text-brand-accent" />
                )}
            </div>
            {error && (
                <span className="text-xs text-red-600">{error}</span>
            )}
        </div>
    );
}

export default ToggleSwitch;
